<template>
  <div
    :class="[spver === 1 ? 'default-film' : 'default-sogou']"
    class="currency-img currency-error-img"
  >
    <div
      v-if="index < 5"
      class="normal-img"
    >
      <img
        v-show="!error"
        :src="imgUrlDeal(src)"
        class="currency-default-img"
        :alt="alt"
        @error="imgError"
      >
    </div>
    <img
      v-else
      v-lazy="imgUrlDeal(src)"
      src=""
      class="currency-default-img"
      :alt="alt"
    >
  </div>
</template>

<script>
const { imgUrlDeal, getSpver } = require('../../common/js/util');

export default {
  props: {
    src: {
      type: String,
      default: ' ',
    },
    alt: {
      type: String,
      default: ' ',
    },
    isResize: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      error: false,
    };
  },
  computed: {
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || 0;
    },
  },
  methods: {
    imgUrlDeal(url) {
      if (this.isResize) {
        return imgUrlDeal(url);
      }

      return url.replace('http://', '//');
    },
    imgError() {
      this.error = true;
    },
    checkhttps(url) {
      if (url.startsWith('http://') && url.indexOf('sogoucdn.com') > -1) {
        return url.replace(/^http:\/\//, 'https://');
      }
      return url;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_search.scss';

.normal-img {
  width: 100%;
  height: 100%;
}
.default-sogou {
  z-index: 0;
  &:before {
    content: '';
    @extend %-absolute-center;
    @include sprite-item('search/sogou');
    z-index: -1;
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.05);
  }
}
img[src=''] {
  opacity: 0;
}
.default-film {
  &:before {
    content: '';
    @extend %-absolute-center;
    @include sprite-item('search/film');
    z-index: -1;
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.05);
  }
}
.currency-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.currency-error-img {
  width: 100%;
  height: 100%;
}
.default-film {
  &:before {
    content: '';
    @extend %-absolute-center;
    @include sprite-item('search/film');
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.05);
  }
}
.currency-default-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 3px;
}
</style>
